import { render, staticRenderFns } from "./AllRoomates.vue?vue&type=template&id=b6753796&scoped=true&"
import script from "./AllRoomates.vue?vue&type=script&lang=js&"
export * from "./AllRoomates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6753796",
  null
  
)

export default component.exports